(function () {
    'use strict';

    angular.module('app').factory('EVSService', EVSService);

    EVSService.$inject = ['$rootScope', 'API'];

    function EVSService($rootScope, API) {
        var service = {};
        /**
         * This callback type is called `requestCallback` and is displayed as a global symbol.
         *
         * @callback requestCallback
         * @param {boolean} success
         * @param {Object} data
         */
        /**
         * @typedef MultiLanguageObject
         * @type {Object}
         * @property {string} en - String on English
         * @property {string} pl - String on Polish
         * @property {string} ru - String on Russian
         * @property {string} uk - String on Ukrainian
         */

        /**
         * Return list of usage external verification system
         *
         * @param {Object} params
         * @param {number} params.page - List page number
         * @param {number} params.count - Messages count in page
         * @param {string} params.date_from - Date and time filter from in RFC3339
         * @param {string} params.date_to - Date and time to from in RFC3339
         * @param {string} params.loyalty_id - Loyalty ID
         * @param {string} params.verified_object - Verified object (phone number, etc) which has been verified (search by contains)
         * @param {string} params.user_id_value - User identifier (search by equals)
         * @param {string} params.user_id_type - Type of user identifier
         * @param {string} params.sort - Sorted field name
         * @param {string} params.order - Sort order
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.getUsage = function (params, callback) {

            API.get('/evs/usage?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                callback(success, data);
            });
        };
        return service;
    }

})();
